import React, { useEffect, useState, useRef } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Scrollbar, A11y } from 'swiper';
import { useDispatch, useSelector } from 'react-redux';
import { CommonApiFun } from '../../Redux/Action/index'
import { useNavigate } from "react-router-dom";
import { routes } from '../../MainPage';
function DoctorsTeam(props) {
    const prevRef = useRef(null);
    const nextRef = useRef(null);
    const dispatch = useDispatch()
    let navigate = useNavigate();
    var TeamArr = useSelector((state) => state.TeamArr)

    const [sliderArr, setSliderArr] = useState([])
    useEffect(() => {
            var data = { action: "team" }
            dispatch(CommonApiFun("api/Api_controller/post", JSON.stringify(data))).then((res) => {
                dispatch({ type: 'TEAM_DATA', payload: res.data })
            }).catch((e) => {
            })
    }, [])
    useEffect(() => {

        const slides = [];
        TeamArr.forEach(async (item, idx) => {

            await slides.push(
                <SwiperSlide className="team_item" key={idx}>
                    <div className="team_inner" onClick={() => { navigate(routes.team + "/" + idx); }}>
                        <a href={routes.team + "/" + idx}>
                            <img src={item.profile_image} alt="team" />
                        </a>
                        <h5>{item.name}</h5>
                        <span className='qualifi_list'>{item.qualifications}</span>
                    </div>
                </SwiperSlide>
            );
        });
        setSliderArr(slides)
    }, [TeamArr])

    return (
        <>
            {TeamArr.length !== 0 && <div className="web-sect blue-bg">
                <div className="team-bg pad-60">
                    <div className="container">
                        <div className="title-box">
                            <span className="subtitle">Our Team</span>
                            <h3 className="text-center">Our Qualified Team</h3>
                        </div>
                        <div className="row team-wrapper">
                            <Swiper className="team_wrap" spaceBetween={0}
                            initialSlide={4}
                                modules={[Navigation, Pagination]}
                                slidesPerView={4}
                                slidestoscroll={4}
                                loop={true}
                                effect={"slide"}
                                allowTouchMove={true}
                                navigation={{
                                    nextEl: ".button-next",
                                    prevEl: ".button-prev",
                                }}
                                breakpoints={{
                                    320: {
                                        slidesPerView: 2,
                                    },
                                    768: {  
                                        slidesPerView: 3,
                                    },
                                    992: {
                                        slidesPerView: 4,
                                    }
                                }}
                                onInit={(swiper) => {
                                    swiper.params.navigation.prevEl = prevRef.current;
                                    swiper.params.navigation.nextEl = nextRef.current;
                                    swiper.navigation.init();
                                    swiper.navigation.update();
                                }}
                            >
                                {sliderArr}
                            </Swiper>

                            {/* Add Arrows */}
                            <div className="swiper-buttons-group">
                                <div className="swiper-button-prev button-prev" ref={prevRef}>
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64">
                                        <path
                                            xmlns="http://www.w3.org/2000/svg"
                                            d="m54 30h-39.899l15.278-14.552c.8-.762.831-2.028.069-2.828-.761-.799-2.027-.831-2.828-.069l-17.448 16.62c-.755.756-1.172 1.76-1.172 2.829 0 1.068.417 2.073 1.207 2.862l17.414 16.586c.387.369.883.552 1.379.552.528 0 1.056-.208 1.449-.621.762-.8.731-2.065-.069-2.827l-15.342-14.552h39.962c1.104 0 2-.896 2-2s-.896-2-2-2z"
                                        />
                                    </svg>
                                </div>
                                <div className="swiper-button-next button-next" ref={nextRef}>
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64">
                                        <path
                                            xmlns="http://www.w3.org/2000/svg"
                                            d="m37.379 12.552c-.799-.761-2.066-.731-2.827.069-.762.8-.73 2.066.069 2.828l15.342 14.551h-39.963c-1.104 0-2 .896-2 2s.896 2 2 2h39.899l-15.278 14.552c-.8.762-.831 2.028-.069 2.828.393.412.92.62 1.448.62.496 0 .992-.183 1.379-.552l17.449-16.62c.756-.755 1.172-1.759 1.172-2.828s-.416-2.073-1.207-2.862z"
                                        />
                                    </svg>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>}
        </>
    );
}

export default DoctorsTeam;